import { FaCalendar, FaCalendarAlt, FaClipboardList, FaExternalLinkAlt, FaEyeSlash, FaFileAlt, FaHistory, FaPen, FaQuestionCircle } from "react-icons/fa";
import { BACKEND } from "../../config/configEnvs";
import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "../ui/Modal";
import { FaEye } from "react-icons/fa";
import Tooltip from "../ui/ToolTip";
import DescriptionModal from "./DescriptionModal";
import HistoricChangesModal from "./HistoricChangesModal";
import { FaCalendarDay, FaCalendarDays } from "react-icons/fa6";
import { FormatDateToDDMMYY } from "../../utils/FormatDate";
import { GetDynamicColor, PlanBackgroundColor } from "../../utils/GetTextColor";
import ChipInfo from "./ChipInfo";
import HandleUpdateSelectSelf from "../../utils/HandleUpdateSelectSelf";

const SoftwareBoxItemContainer = ({ service, client, user, permissions, allServiciosList, workers }) => {
  
  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  const [newComment, setNewComment] = useState("");

  const [openModal, setOpenModal] = useState(false)

  const [serviceData, setServiceData] = useState(() => 
    client.services.find((serv) => serv.servicio.name === service.name)
  );

  const handleAddComment = async () => {
    if (!newComment.trim()) {
      toast.error("Por favor, ingresa un comentario antes de enviar.");
      return;
    }
  
    const nuevoComentario = {
      usuario: user.id, // Solo el ID del usuario
      comentario: newComment,
      fecha: new Date().toISOString(),
    };
  
    // Usa el estado actual para construir el nuevo estado local
    const comentariosOperativa = serviceData.comentariosOperativa || [];
    
    // Asegurarse de que todos los comentarios tengan solo el ID del usuario
    const updatedComentariosOperativa = [
      ...comentariosOperativa.map((comentario) => ({
        ...comentario,
        usuario: typeof comentario.usuario === "object" ? comentario.usuario.id : comentario.usuario,
      })),
      nuevoComentario,
    ];
  
    const updatedServiceData = {
      ...serviceData,
      comentariosOperativa: updatedComentariosOperativa,
    };
  
    // Actualiza el estado local
    setServiceData(updatedServiceData);
  
    try {
      // Envía la actualización al backend
      await axios.put(
        `${BACKEND}/api/serviciosCotizaciones/${updatedServiceData.id}`,
        { comentariosOperativa: updatedServiceData.comentariosOperativa }
      );
  
      toast.success("Comentario agregado con éxito");
      setNewComment("");
    } catch (error) {
      console.log(error);
      toast.error("Error al agregar el comentario");
    }
  };

  const getStatusClass = (estado) => { // Color del texto del estado del servicio
    switch (estado) {
      case "Terminado con exito":
          return "text-green-500 font-bold";
      case "Por comenzar":
          return "text-yellow-300 font-bold";
      case "En proceso":
          return "text-blue-500 font-bold";
      case "Abandonado":
          return "text-black font-bold";
      case "Congelado":
          return "text-sky-300 font-bold";
      default:
          return "text-gray-500 font-bold";
    }
  };

  /// Historial de cambios

  const [openModalHistory, setOpenModalHistory] = useState(false) // Modal de historial de cambios

  const handleUpdateField = async (field, newStatus) => { // Cambiar el campo
    const changeHistory = serviceData.historialCambios ? [...serviceData.historialCambios] : [];

    const newChange = {
      worker: user,
      field: field,
      oldValue: serviceData[field],
      newValue: newStatus,
      date: new Date().toISOString(),
    };

    changeHistory.push(newChange);

    const transformedHistory = changeHistory.map(change => ({
      ...change,
      worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
    }));

    try {
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceData.id}`, {
        [field]: newStatus === "Seleccionar" ? null : newStatus,
        historialCambios: transformedHistory, // Enviar el array actualizado
      });

      toast.success("Estado actualizado con éxito");
  
      setServiceData((prevData) => ({
        ...prevData,
        [field]: newStatus,
        historialCambios: changeHistory,
      }));
    } catch (error) {
      console.error(error);
      toast.error("Error al actualizar el estado");
    }
  };

  const handleUpdateDate = (field, newDate) => { // Cambiar la fecha con lógica de debouncer

    setServiceData((prevData) => ({
      ...prevData,
      [field]: newDate,
    }));

    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
    debounceUpdate.current = setTimeout(async () => {

      try {
        const changeHistory = serviceData.historialCambios ? [...serviceData.historialCambios] : [];

        const newChange = {
          worker: user,
          field: field,
          oldValue: serviceData[field],
          newValue: newDate,
          date: new Date().toISOString(),
        };

        changeHistory.push(newChange);

        const transformedHistory = changeHistory.map(change => ({
          ...change,
          worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
        }));

        await axios.put(`${BACKEND}/api/serviciosCotizaciones/${serviceData.id}`, {
          [field]: newDate || null,
          historialCambios: transformedHistory, // Enviar el array actualizado
        });

        setServiceData((prevData) => ({
          ...prevData,
          historialCambios: changeHistory,
        }));

        toast.success("Dato actualizado con éxito");
      } catch (error) {
        console.error(error);
        toast.error("Error al actualizar la fecha");
      }
    }, 1000); // Esperar 2 secs luego de que el usuario deja de ecsribir
  };

  // Ver descripción del servicio

  const [openModalDescription, setOpenModalDescription] = useState(false)

  const parseDescription = (description) => { // Parsear la info
    if (!description || typeof description !== "string") {
      return [];
    }
    return description.split("\n").map((item) => {
      const [key, value] = item.split(":");
      return {
        key: key ? key.trim() : "",
        value: value ? (value.trim() === "✓" ? "Si" : value.trim()) : "-",
      };
    });
  };  

  const descriptionText = serviceData?.customDescriptionActive
  ? serviceData?.customDescriptionText
  : serviceData?.servicio.preciosUnitarios.find(
      (precioUnit) => precioUnit?.plan.id === serviceData?.planServicio.id
    )?.descripcion;

  const parsedDescription = parseDescription(descriptionText);

  const percetageColor = [
    { min: 0, max: 50, color: "text-red-500" },
    { min: 51, max: 80, color: "text-blue-500" },
    { min: 81, max: 100, color: "text-green-500" }
  ]
  
  return (
    <td scope="row" className="px-4 py-2 max-w-xs border border-gray-300 truncate text-center">
      {(() => {
        if (serviceData) {
          return (
            <div className="flex flex-col gap-1">

              <Modal
                activeModal={openModal}
                onClose={() => setOpenModal(false)}
                title="Comentarios proyecto"
                centered
              >
                <div className="flex flex-col gap-2">

                  <div className="text-xs text-gray-800 font-semibold text-lg">
                    <span className="font-bold">Cliente: </span>
                    <span className="font-light">{serviceData?.cotizacion?.cliente?.nombreComercial}</span>
                  </div>

                  <div className="text-xs text-gray-800 font-semibold text-lg">
                    <span className="font-bold">Servicio: </span>
                    <span className="font-light">{serviceData.servicio.name}</span>
                  </div>

                  <h3 className="text-xs font-bold text-gray-700 mt-3">Comentarios:</h3>
                  {/* Sección de comentarios */}
                  <div className="max-h-[300px] overflow-y-auto">
                    {serviceData.comentariosOperativa?.map((comment, index) => (
                      <div key={index} className="mb-2 px-4 py-2 rounded-lg border border-gray-200 shadow-sm bg-white">

                        <div className="flex flex-row justify-between items-center space-x-3 mb-2">
                          <div className="flex flex-row gap-2 items-center justify-center">
                            <img
                              src={comment?.usuario?.foto?.url || user?.foto?.url}
                              alt={comment?.usuario?.nombre || user.nombre}
                              className="w-8 h-8 rounded-full object-cover"
                            />
                            <span className="text-xs font-semibold text-gray-800">{comment?.usuario?.name || user.name} - <span className="text-xs font-light text-gray-600 lowercase">{comment?.usuario.puesto || user.puesto}</span></span>
                          </div>
                          <div className="text-xs text-gray-500">{new Date(comment.fecha).toLocaleString()}</div>
                        </div>

                        <div className="text-gray-700 text-xs border bordar-gray-200 rounded-md px-2 py-1">{comment.comentario}</div>
                      </div>
                    ))}
                  </div>

                  {/* Sección para agregar un nuevo comentario */}
                  <div className="mt-3">
                    <h3 className="text-xs font-bold text-gray-700">Añadir comentario:</h3>
                    <textarea
                      className="w-full p-3 mt-2 border text-xs border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      rows="2"
                      placeholder="Escribe tu comentario aquí..."
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                    />
                    <button
                      onClick={handleAddComment}
                      className="mt-3 px-4 py-2 bg-blue-600 text-xs text-white rounded-md hover:bg-blue-700 focus:outline-none"
                    >
                      Agregar Comentario
                    </button>
                  </div>
                </div>
              </Modal>

              <HistoricChangesModal
                openModalHistory = {openModalHistory}
                brandName = {serviceData.servicio.name}
                serviceName = {serviceData?.cotizacion?.cliente?.nombreComercial}
                historicChanges = {serviceData.historialCambios}
                parsedDescription = {parsedDescription}
                setOpenModalHistory = {setOpenModalHistory}
                user = {user}
              />

              <DescriptionModal
                openModalDescription = {openModalDescription}
                brandName = {serviceData.servicio.name}
                serviceName = {serviceData?.cotizacion?.cliente?.nombreComercial}
                parsedDescription = {parsedDescription}
                setOpenModalDescription = {setOpenModalDescription}
              />

              {/* Ir al proyecto */}
              <div className="mb-1 flex flex-row justify-between">

                <div>
                  <a 
                    href={`/home/seguimiento/${serviceData.cotizacion.cliente.id}/${serviceData.servicio.name}/${serviceData.id}`}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex flex-row justify-center items-center gap-2 font-bold hover:cursor-pointer hover:underline transition-all duration-100"
                  >
                    Ir al Proyecto
                    <FaExternalLinkAlt className="text-blue-500"/>
                  </a>
                </div>
                  
                <Tooltip content={"Historial de cambios"}>
                  <div onClick={() => setOpenModalHistory(true)}>
                    <FaHistory className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                  </div>
                </Tooltip>

              </div>

              {/* Plan */}
              <div className="mb-1 flex flex-row justify-between">
                <span className="font-semibold">Plan: </span>
                <span className={`font-semibold px-2 ${PlanBackgroundColor[serviceData.planServicio.name]}`}>
                  {serviceData.planServicio.name}
                </span>
              </div>

              {/* Checklist */}
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">CheckList: </span>
                  {ChipInfo("Sistema")}
                </div>
                <span className={`text-xs ${serviceData.checklistCompleted || serviceData.checkList === "Si" ? "text-green-500" : "text-red-500"}`}>
                  {serviceData.checklistCompleted || serviceData.checkList === "Si" ? "Si" : "No"}
                </span>
              </div>

              {/* Estado */}
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Estado: </span>
                  {ChipInfo("Admin")}
                </div>
                <select 
                  value={serviceData.estado}
                  onChange={(e) => handleUpdateField("estado", e.target.value)}
                  className={`px-2 py-0 w-[40%] hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs ${getStatusClass(serviceData.estado)}`}
                  disabled={!permissions.isAdmin && !permissions.isAssistant && !permissions.isBossArea}
                >
                  <option value="Por comenzar" className="text-yellow-300 hover:cursor-pointer">Por comenzar</option>
                  <option value="En proceso" className="text-blue-500 hover:cursor-pointer">En proceso</option>
                  <option value="Terminado con exito" className="text-green-500 hover:cursor-pointer">Terminado con exito</option>
                  <option value="Congelado" className="text-sky-300 hover:cursor-pointer">Congelado</option>
                  <option value="Abandonado" className="text-black hover:cursor-pointer">Abandonado</option>
                </select>
              </div>

              {/* Fecha ingreso */}
              <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Fecha ingreso: </span>
                  {ChipInfo("Admin")}
                  <Tooltip content={"Fecha de cuando el cliente realizó el primer pago."}>
                    <div>
                      <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                </div>
                <input
                  type="date"
                  value={serviceData.fechaIngreso ? serviceData.fechaIngreso.split('T')[0] : ""}
                  onChange={(e) => handleUpdateDate("fechaIngreso", e.target.value)}
                  disabled
                  className={`px-2 w-[40%] py-0 hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                />
              </div>

              {/* Fecha inicio */}
              <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Fecha Inicio: </span>
                  {ChipInfo("Sistema")}
                  <Tooltip content={"Fecha de la primera reunión del área operativa con el cliente."}>
                    <div>
                      <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                </div>
                <input
                  type="date"
                  value={serviceData.fechaInicio ? serviceData.fechaInicio.split('T')[0] : ""}
                  onChange={(e) => handleUpdateDate("fechaInicio", e.target.value)}
                  disabled={!(permissions.isAdmin)}
                  className={`px-2 w-[40%] py-0 hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                />
              </div>

              {/* Fecha fin */}
              <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Fecha fin: </span>
                  {ChipInfo("Admin")}
                  <Tooltip content={"Fecha establecida por administración para terminar el proyecto."}>
                    <div>
                      <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                </div>
                <input
                  type="date"
                  value={serviceData.fechaFin ? serviceData.fechaFin.split('T')[0] : ""}
                  onChange={(e) => handleUpdateDate("fechaFin", e.target.value)}
                  disabled={!permissions.isAdmin}
                  className={`px-2 w-[40%] py-0 hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                />
              </div>

              {/* Fecha entrega */}
              <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Fecha Entrega: </span>
                  {ChipInfo("Admin")}
                  <Tooltip content={"Fecha de entrega de la web una vez el cliente pagó el 100%. Entrega de credenciales, video de capacitación, migracion al hosting del cliente (en caso sea necesario), etc. Servicio 100% completado."}>
                    <div>
                      <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                </div>
                <input
                  type="date"
                  value={serviceData.fechaEntrega ? serviceData.fechaEntrega.split('T')[0] : ""}
                  onChange={(e) => handleUpdateDate("fechaEntrega", e.target.value)}
                  disabled={!permissions.isAdmin}
                  className={`px-2 w-[40%] py-0 hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                />
              </div>

              {/* Duración del proyecto */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">
                  <div className="flex flex-row gap-1 items-center">
                    <span>Duración del proyecto </span>
                    <Tooltip content={"Duración total del proyecto (en días), establecida por administración."}>
                      <div>
                        <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                      </div>
                    </Tooltip>
                  </div>
                </span>

                <div className="flex items-center justify-center gap-2">
                  {Math.ceil((new Date(serviceData.fechaFin).getTime() - new Date(serviceData.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))}
                  <FaCalendarDays className="text-black" />
                </div>
              </div>

              {/* Días de retraso */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">
                  {serviceData.estado === 'Terminado con exito' ? (
                    // Si está "Terminado con exito"
                    serviceData.fechaFin && serviceData.fechaEntrega ? (
                      Math.ceil((new Date(serviceData.fechaFin).getTime() - new Date(serviceData.fechaEntrega).getTime()) / (1000 * 60 * 60 * 24)) < 0
                        ? 
                          <div className="flex flex-row gap-1 items-center">
                            <span>Días de retraso: </span>
                            <Tooltip content={"El proyecto se retrasó la cantidad de días indicada en relación a la fecha de fin establecida por administración"}>
                              <div>
                                <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                              </div>
                            </Tooltip>
                          </div>
                         // Si la diferencia es negativa (retraso)
                        : 
                        <div className="flex flex-row gap-1 items-center">
                          <span>Días de retraso: </span>
                          <Tooltip content={"El proyecto se retrasó la cantidad de días indicada en relación a la fecha de fin establecida por administración"}>
                            <div>
                              <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                            </div>
                          </Tooltip>
                        </div>
                    ) : (
                      "-"
                    )
                  ) : (
                    // Si está en proceso
                    <div className="flex flex-row gap-1 items-center">
                      <span>Días para la entrega </span>
                      <Tooltip content={"El proyecto debería entregarse en la cantidad de días indicada, si está en rojo significa que el proyecto va retrasado en la cantidad de días indicada."}>
                        <div>
                          <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                        </div>
                      </Tooltip>
                    </div>
                  )}
                </span>
                
                {serviceData.estado === 'Terminado con exito' ? (
                  // Si está "Terminado con exito"
                  serviceData.fechaFin && serviceData.fechaEntrega ? (
                    <span
                      className={`font-bold ${
                        Math.ceil((new Date(serviceData.fechaFin).getTime() - new Date(serviceData.fechaEntrega).getTime()) / (1000 * 60 * 60 * 24)) < 0
                          ? 'text-red-500' // Si hay retraso
                          : 'text-green-500' // Si no hay retraso
                      }`}
                    >
                      {Math.abs(Math.ceil((new Date(serviceData.fechaFin).getTime() - new Date(serviceData.fechaEntrega).getTime()) / (1000 * 60 * 60 * 24)))}
                    </span>
                  ) : (
                    "-"
                  )
                ) : (
                  // Si está en proceso
                  serviceData.fechaFin ? (
                    <span
                      className={`font-bold ${
                        new Date(serviceData.fechaFin).getTime() < new Date().getTime() ? 'text-red-500' : 'text-green-500'
                      }`}
                    >
                      {Math.ceil((new Date(serviceData.fechaFin).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))}
                    </span>
                  ) : (
                    "-"
                  )
                )}
              </div>

              {/* Duración del proyecto */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">
                  {serviceData.estado === 'Terminado con exito' ? (
                    // Si está "Terminado con exito"
                    serviceData.fechaInicio && serviceData.fechaEntrega ? (
                      <div className="flex flex-row gap-1 items-center">
                        <span>Duración del proyecto </span>
                        <Tooltip content={"Días totales que duró el proyecto."}>
                          <div>
                            <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                          </div>
                        </Tooltip>
                      </div>
                      //"Duración del proyecto: "
                    ) : (
                      "-"
                    )
                  ) : (
                    // Si está en proceso
                    <div className="flex flex-row gap-1 items-center">
                      <span>Duración hasta la fecha: </span>
                      <Tooltip content={"Días que lleva el proyecto en proceso, desde la fecha de inicio hasta hoy."}>
                        <div>
                          <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                        </div>
                      </Tooltip>
                    </div>
                    //"Duración hasta la fecha:""
                  )}
                </span>

                {serviceData.estado === 'Terminado con exito' ? (
                  // Si está "Terminado con exito"
                  serviceData.fechaInicio && serviceData.fechaEntrega ? (
                    <span className="font-bold text-green-500">
                      {Math.ceil((new Date(serviceData.fechaEntrega).getTime() - new Date(serviceData.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))}
                    </span>
                  ) : (
                    "-"
                  )
                ) : (
                  // Si está en proceso
                  serviceData.fechaInicio ? (
                    <span className="font-bold text-green-500">
                      {Math.ceil((new Date().getTime() - new Date(serviceData.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))}
                    </span>
                  ) : (
                    "-"
                  )
                )}
              </div>

              {/* Formulario */}
              <div className="flex flex-row justify-between items-center">
                <span className="font-semibold">Formulario: </span>
                {serviceData.form ? (
                  serviceData.form.respondido ? (
                    <a 
                      href={`/home/seguimiento/encuestas-respuestas/${serviceData.form.id}`}
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                    >
                      <span>Respondido</span>
                      <FaExternalLinkAlt className="text-blue-500" />
                    </a>
                  ) : (
                    <span>No respondido</span>
                  )
                ) : (
                  <span>No asignado</span>
                )}
              </div>

              {/* Link de desarrollo */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Link de desarrollo: </span>
                {serviceData?.links?.find((l) => l.titulo === "Link demo")?.url ? (
                    <a 
                      href={serviceData.links.find((l) => l.titulo === "Link demo").url}
                      target="_blank" 
                      rel="noreferrer"
                      className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                    >
                      <span>Link</span>
                      <FaExternalLinkAlt className="text-blue-500" />
                    </a>
                  ):( 
                    <FaEyeSlash />
                  )
                }
              </div>

              {/* Link oficial */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Link oficial: </span>
                {serviceData?.links?.find((l) => l.titulo === "Link web oficial")?.url ? (
                    <a 
                      href={serviceData.links.find((l) => l.titulo === "Link web oficial").url}
                      target="_blank" 
                      rel="noreferrer"
                      className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                    >
                      <span>Link</span>
                      <FaExternalLinkAlt className="text-blue-500" />
                    </a>
                  ):( 
                    <FaEyeSlash />
                  )
                }
              </div>

              {/* Link Github */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Link Github: </span>
                {serviceData?.linkGithub ? (
                    <a 
                      href={serviceData.linkGithub}
                      target="_blank" 
                      rel="noreferrer"
                      className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                    >
                      <span>Link</span>
                      <FaExternalLinkAlt className="text-blue-500" />
                    </a>
                  ):( 
                    <FaEyeSlash />
                  )
                }
              </div>

              {/* Link flujo */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Link flujo: </span>
                {serviceData?.linkFlujo ? (
                    <a 
                      href={serviceData.linkFlujo}
                      target="_blank" 
                      rel="noreferrer"
                      className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                    >
                      <span>Link</span>
                      <FaExternalLinkAlt className="text-blue-500" />
                    </a>
                  ):( 
                    <FaEyeSlash />
                  )
                }
              </div>

              {/* Link roadmap */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Link roadmap: </span>
                {serviceData?.linkRoadmap ? (
                    <a 
                      href={serviceData.linkRoadmap}
                      target="_blank" 
                      rel="noreferrer"
                      className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                    >
                      <span>Link</span>
                      <FaExternalLinkAlt className="text-blue-500" />
                    </a>
                  ):( 
                    <FaEyeSlash />
                  )
                }
              </div>
              
              {/* Link esquema */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Link esquema: </span>
                {serviceData?.linkEsquemaBaseDatos ? (
                    <a 
                      href={serviceData.linkEsquemaBaseDatos}
                      target="_blank" 
                      rel="noreferrer"
                      className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                    >
                      <span>Link</span>
                      <FaExternalLinkAlt className="text-blue-500" />
                    </a>
                  ):( 
                    <FaEyeSlash />
                  )
                }
              </div>

              {/* Link manual de uso */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Link manual de uso: </span>
                {serviceData?.linkManualUso ? (
                    <a 
                      href={serviceData.linkManualUso}
                      target="_blank" 
                      rel="noreferrer"
                      className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                    >
                      <span>Link</span>
                      <FaExternalLinkAlt className="text-blue-500" />
                    </a>
                  ):( 
                    <FaEyeSlash />
                  )
                }
              </div>

              {/* Link capacitación */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Link capacitación: </span>
                {serviceData?.linkCapacitacion ? (
                    <a 
                      href={serviceData.linkCapacitacion}
                      target="_blank" 
                      rel="noreferrer"
                      className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                    >
                      <span>Link</span>
                      <FaExternalLinkAlt className="text-blue-500" />
                    </a>
                  ):( 
                    <FaEyeSlash />
                  )
                }
              </div>

              {/* Web referencia */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Web referencia: </span>
                {serviceData?.webReferencia ?    
                  <a 
                    href={serviceData.webReferencia}
                    target="_blank" 
                    rel="noreferrer"
                    className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                  >
                    <span>Link</span>
                    <FaExternalLinkAlt className="text-blue-500" />
                  </a>
                  : 
                  <FaEyeSlash />
                }
              </div>

              {/* Copia seguridad ref */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Copia seguridad ref: </span>
                {serviceData?.copiaSeguridadReferencia ?    
                  <a 
                    href={serviceData.copiaSeguridadReferencia}
                    target="_blank" 
                    rel="noreferrer"
                    className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                  >
                    <span>Link</span>
                    <FaExternalLinkAlt className="text-blue-500" />
                  </a>
                  : 
                  <FaEyeSlash />
                }
              </div>

              {/* Fecha envío info */}
              <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Fecha envío info: </span>
                  <Tooltip content={"Fecha en la que el cliente terminó de enviar el 100% de la información."}>
                    <div>
                      <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                </div>
                {serviceData?.fechaInfoCompleta ?    
                  <div className="flex items-center gap-2">
                    <span>{FormatDateToDDMMYY(new Date(serviceData.fechaInfoCompleta))}</span>
                    <FaCalendarDay className="text-bblack" />
                  </div>
                  : 
                  <FaEyeSlash />
                }
              </div>

              {/* Duración real */}
              <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Duración real: </span>
                  <Tooltip content={"Duración real del proyecto, desde que el cliente envió el 100% de la información hasta que el área operativa terminó la web (sin incluir entrega de credenciales, capacitación, etc)."}>
                    <div>
                      <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                </div>
                <span className="flex flex-row gap-1 items-center">
                  {serviceData.fechaInfoCompleta ? (
                    serviceData.estado === "En proceso"
                      ? Math.ceil((new Date().getTime() - new Date(serviceData.fechaInfoCompleta).getTime()) / (1000 * 60 * 60 * 24))
                      : serviceData.estado === "Terminado con exito" && serviceData.fechaEntrega
                      ? Math.ceil((new Date(serviceData.fechaEntrega).getTime() - new Date(serviceData.fechaInfoCompleta).getTime()) / (1000 * 60 * 60 * 24))
                      : "N/A"
                  ) : "N/A"}
                </span>
              </div>

              {/* Información enviada */}
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Información enviada: </span>
                  {ChipInfo("Especialista")}
                </div>
                <select 
                  value={serviceData.informacionEnviada}
                  onChange={(e) => {
                    handleUpdateField("informacionEnviada", e.target.value);
                    if (e.target.value === "Envió todo") {
                      handleUpdateField("fechaInfoCompleta", new Date())
                    }
                  }}
                  className={`px-2 w-[40%] py-0 border border-gray-300 focus:outline-none rounded-md text-xs hover:cursor-pointer
                    ${serviceData.informacionEnviada === "No envió nada" ? "text-red-500" : 
                      serviceData.informacionEnviada === "Envió poco" ? "text-yellow-400" : 
                      serviceData.informacionEnviada === "Envió todo" ? "text-green-500" : 
                      "text-gray-500"}`}
                  disabled={false}
                >
                  <option value="Por confirmar" className="text-black">Por confirmar</option>
                  <option value="No envió nada" className="text-red-500">No envió nada</option>
                  <option value="Envió poco" className="text-yellow-400">Envió poco</option>
                  <option value="Envió todo" className="text-green-500">Envió todo</option>
                </select>
              </div>

              {/* Porcentaje proyecto */}
              <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Porcentaje proyecto: </span>
                  {ChipInfo("Especialista")}
                </div>
                <input
                  type="number"
                  value={serviceData.porcentajeAvance ? serviceData.porcentajeAvance : 0}
                  min={0}
                  max={100}
                  onChange={(e) => {
                    let value = parseInt(e.target.value, 10);
                
                    if (isNaN(value)) value = 0;
                    if (value < 0) value = 0;
                    if (value > 100) value = 100;
                
                    handleUpdateDate("porcentajeAvance", value);
                  }}
                  className={`px-2 font-bold w-[40%] ${GetDynamicColor(serviceData.porcentajeAvance ,percetageColor)} py-0 hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                />
              </div>

              {/* Capacitación hecha */}
              <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Capacitación hecha: </span>
                  {ChipInfo("Especialista")}
                </div>
                <select 
                  value={serviceData.capacitacionHecha}
                  onChange={(e) => handleUpdateField("capacitacionHecha", e.target.value)}
                  className={`px-2 w-[40%] py-0 hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs
                    ${serviceData.capacitacionHecha === "Si" ? "text-green-500" : 
                      serviceData.capacitacionHecha === "No" ? "text-red-500" :
                      "text-gray-500"}`}
                  disabled={false}
                >
                  <option value="No" className="hover:cursor-pointer text-red-500">No</option>
                  <option value="Si" className="hover:cursor-pointer text-green-500">Si</option>
                </select>
              </div>

              {/* Link capacitación */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Link capacitación: </span>
                {serviceData?.linkCapacitacion ?    
                  <a 
                    href={serviceData.linkCapacitacion}
                    target="_blank" 
                    rel="noreferrer"
                    className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                  >
                    <span>Link</span>
                    <FaExternalLinkAlt className="text-blue-500" />
                  </a>
                  : 
                  <FaEyeSlash />
                }
              </div>

              {/* Precio venta */}
              {user.area.toUpperCase() === "ADMINISTRACION" && (
                <div className="flex flex-row justify-between">

                  <div className="flex flex-row gap-1">
                    <span className="font-semibold">Precio Venta: </span>
                  </div>
  
                  <span>
                  {serviceData.cotizacion.moneda}{" "}
                    {(() => {
                      const servicioEncontrado = allServiciosList.find(
                        (e) => e.id === serviceData.servicio.id
                      );
  
                      const precioUnitario = servicioEncontrado?.preciosUnitarios?.find(
                        (ev2) => ev2.plan?.id === serviceData.planServicio?.id
                      )?.precio;
  
                      const precioBase = serviceData.customPriceActive
                        ? serviceData.customPrice * serviceData.numeroItems
                        : precioUnitario
                        ? precioUnitario * serviceData.numeroItems
                        : 0; // Si no encuentra el precio, evitar que sea undefined
  
                      // Calcular el descuento
                      let montoDescuento = 0;
                      if (serviceData.tipoDescuento === "Porcentaje") {
                        montoDescuento = precioBase * (serviceData.montoDescuento / 100);
                        console.log(montoDescuento)
                      } else if (serviceData.tipoDescuento === "Fijo") {
                        montoDescuento = serviceData.montoDescuento;
                      }
  
                      // Restar el descuento del precio base
                      return precioBase - montoDescuento;
                    })()}
                  </span>
  
                </div>
              )}

              {/* Facturación */}
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Facturación: </span>
                  {ChipInfo("Sistema")}
                </div>
                <select
                  value={serviceData.facturacion || "Seleccionar"}
                  //onChange={(e) => handleUpdateField("facturacion", e.target.value)}
                  //disabled={!permissions.isAdmin}
                  disabled
                  className={`px-2 w-[40%] py-0 hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs ${
                    serviceData.facturacion === "Deuda"
                      ? "text-red-500"
                      : serviceData.facturacion === undefined || serviceData.facturacion === null || serviceData.facturacion === "Seleccionar"
                      ? "text-black"
                      : "text-green-500"
                  }`}
                >
                  <option value="Seleccionar" className="hover:cursor-pointer text-black">Seleccionar</option>
                  <option value="Deuda" className="hover:cursor-pointer text-red-500">Deuda</option>
                  <option value="Pagado" className="hover:cursor-pointer text-green-500">Pagado</option>
                </select>
              </div>

              {/* Encargado */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Encargado: </span>
                <span>{serviceData.cotizacion?.cliente?.encargadoProyecto ? `${serviceData.cotizacion?.cliente?.encargadoProyecto}` : "-"}</span>
              </div>

              {/* Nro. Encargado */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Nro. Encargado: </span>
                <span>{serviceData.cotizacion?.cliente?.telefono ? `${serviceData.cotizacion?.cliente?.telefono}` : "-"}</span>
              </div>

              {/* Vendedor */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Vendedor: </span>
                <span>{serviceData.cotizacion?.cotizador?.name ? `${serviceData.cotizacion?.cotizador?.name}` : "-"}</span>
              </div>

              {/* Responsable cobranza */}
              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-row gap-1 items-center">
                  <span className="font-semibold">Responsable cobranza: </span>
                  <Tooltip content={"Vendedor responsable de la cobranza del proyecto."}>
                    <div>
                      <FaQuestionCircle className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                  {ChipInfo("Admin")}
                </div>
                <select 
                  value={serviceData?.encargadoCobranza ? (serviceData?.encargadoCobranza?.id || serviceData.encargadoCobranza) : serviceData.cotizacion?.cotizador?.id}
                  onChange={(e) => HandleUpdateSelectSelf("encargadoCobranza", e.target.value, serviceData.id, "serviciosCotizaciones", setServiceData)}
                  className={`px-2 py-0 w-[40%] hover:cursor-pointer border border-gray-300 focus:outline-none rounded-md text-xs`}
                  disabled={!permissions.isAdmin && !permissions.isAssistant}
                >
                  {workers.map(worker => (
                    <option key={worker.id} value={worker.id} className="hover:cursor-pointer">{worker.name}</option>
                  ))}
                </select>
              </div>

              {/* Responsable cobranza */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Responsable cobranza: </span>
                <span>{serviceData.cotizacion?.cotizador?.name ? `${serviceData.cotizacion?.cotizador?.name}` : "-"}</span>
              </div>

              {/* Responsable */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Responsable: </span>
                <span>{serviceData.responsable?.name ? `${serviceData.responsable?.name}` : "-"}</span>
              </div>

              {/* Comentarios vendedor */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Comentarios vendedor: </span>
                {serviceData.comentarioVendedor ? (
                  <Tooltip content={`${serviceData.comentarioVendedor}`} interactive={true}>
                    <div>
                      <FaEye className="hover:text-orange-500 transition-all duration-200 hover:cursor-pointer"/>
                    </div>
                  </Tooltip>
                ) : (
                  <div>
                    <FaEyeSlash />
                  </div>
                )}
              </div>

              {/* Descripción servicio */}
              <div className="flex flex-row justify-between">
                <span className="font-semibold">Descripción servicio: </span>
                {parsedDescription ? (
                <button 
                  onClick={() => setOpenModalDescription(true)}
                  className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                >
                  <span>Ver</span>
                  <FaFileAlt className="text-blue-500" />
                </button>

                ) : (
                  <div>
                    <FaEyeSlash />
                  </div>
                )}
              </div>

              {/* Comentarios proyecto */}
              <div className="flex mt-1 items-center justify-center">
                <button 
                  onClick={() => setOpenModal(true)}
                  className="flex flex-row justify-center items-center gap-2 font-bold hover:cursor-pointer hover:underline transition-all duration-100"
                >
                  Comentarios proyecto
                  <FaPen className="text-blue-500"/>
                </button>
              </div>

              {/* Audios */}
              {serviceData.audios && serviceData.audios?.length > 0 && (
                <div className="flex flex-col gap-2">
                  <span className="font-semibold text-left">Audios: </span>
                  <div className="flex flex-col gap-2 w-full">
                    {serviceData.audios.map((audio) => (
                      <div className="flex items-center gap-2">
                        <audio 
                          src={audio.url} 
                          controls 
                          className="w-full h-4 [&::-webkit-media-controls-time-remaining-display]:text-xs [&::-webkit-media-controls-current-time-display]:text-xs"
                          controlsList="nodownload"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {/* Servicios vinculados */}
              {serviceData.associatedServices && serviceData.associatedServices?.length > 0 && (
                <div className="flex mt-2 gap-2 flex-wrap">
                  <span className="font-semibold">Servicios vinculados: </span>
                  {serviceData.associatedServices?.map(associatedService => (
                    <a 
                      key={associatedService.serviceId} // Siempre añade un key al map
                      href={`/home/seguimiento/${associatedService.brandId}/${associatedService.serviceName}/${associatedService.serviceId}`}
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="flex items-center justify-center px-2 py-0.5 bg-orange-500 rounded-full text-white font-semibold text-xs hover:bg-orange-600 transition-all"
                    >
                      {associatedService.serviceName}
                    </a>
                  ))}
                </div>
              )}

            </div>
          );
        } else {
          return (
            <span className="text-xs text-gray-200">-</span>
          );
        }
      })()}
    </td>
  )
}

export default SoftwareBoxItemContainer